export const erdEdgeBlankSlate = (
  <svg width="310" height="40" viewBox="0 0 310 40" fill="none">
    <rect width="310" height="16" rx="8" fill="#F0F0F0" />
    <rect y="24" width="310" height="16" rx="8" fill="#F0F0F0" />
  </svg>
);
